import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/service/auth.service';
import { inject } from '@angular/core';
import { NotificationService } from '../shared/notification-service/notification.service';
import { Log } from '../logger.service';

export const workforceGuard: CanActivateFn = (route, state) => {
  return true;

  // const auth = inject(AuthService);
  // const router = inject(Router);
  // const notify = inject(NotificationService);

  // const orgs = auth.getOrgsValue;
  // const workforceOrg = orgs.find((org) => {
  //   return org.settings?.moneyball?.features?.workforce;
  // });

  // if (workforceOrg) {
  //   auth.setSelectedOrgId(workforceOrg.id);
  //   return true;
  // } else {
  //   notify.error('Workforce is not enabled for your account');
  //   return router.navigateByUrl('/login');
  // }
};
